import React from 'react'
import { FormControl, Select, MenuItem, Box, Typography, IconButton, Tooltip, Input } from '@material-ui/core'
import InstagramIcon from '@material-ui/icons/Instagram'
import FacebookIcon from '@material-ui/icons/Facebook'
import SearchIcon from '@material-ui/icons/Search'
import YouTubeIcon from '@material-ui/icons/YouTube'
import AndroidIcon from '@material-ui/icons/Android'
import WhatsAppIcon from '@material-ui/icons/WhatsApp'
import PersonAddIcon from '@material-ui/icons/PersonAdd'
import LanguageIcon from '@material-ui/icons/Language'
import MoreHorizIcon from '@material-ui/icons/MoreHoriz'
import { i18n } from '../../translate/i18n'

export const LEAD_SOURCES = [
  { value: 'instagram', Icon: InstagramIcon },
  { value: 'facebook', Icon: FacebookIcon },
  { value: 'google_ads', Icon: SearchIcon },
  { value: 'youtube', Icon: YouTubeIcon },
  { value: 'ai', Icon: AndroidIcon },
  { value: 'whatsapp', Icon: WhatsAppIcon },
  { value: 'referral', Icon: PersonAddIcon },
  { value: 'site', Icon: LanguageIcon },
  { value: 'other', Icon: MoreHorizIcon },
]

export const leadSourceLabel = value => {
  const source = LEAD_SOURCES.find(s => s.value === value)
  return i18n.t(`contactModal.form.leadSource.${source ? source.value : 'unset'}`)
}

export const LeadSourceIcon = ({ value, fontSize = 'small', color = 'inherit' }) => {
  const source = LEAD_SOURCES.find(s => s.value === value)
  if (!source) return null
  const { Icon } = source
  return <Icon fontSize={fontSize} style={{ color }} />
}

const LeadSourceSelector = ({ value = '', onChange, disabled, label, dense = false }) => {
  return (
    <FormControl variant={dense ? 'standard' : 'outlined'} fullWidth={!dense} margin={dense ? 'none' : 'dense'} disabled={disabled}>
      {label && (
        <Typography variant='caption' style={{ marginBottom: 4, display: 'block', color: 'rgba(0, 0, 0, 0.54)' }}>
          {label}
        </Typography>
      )}
      <Select
        displayEmpty
        input={dense ? <Input disableUnderline /> : undefined}
        value={value || ''}
        onClick={event => dense && event.stopPropagation()}
        onChange={event => onChange && onChange(event.target.value)}
        style={dense ? { fontSize: 12 } : undefined}
        renderValue={selected => {
          if (!selected) {
            return (
              <Typography color='textSecondary' style={dense ? { fontSize: 12 } : undefined}>
                {i18n.t('contactModal.form.leadSource.unset')}
              </Typography>
            )
          }
          const source = LEAD_SOURCES.find(s => s.value === selected)
          if (!source) return selected
          const { Icon } = source
          return (
            <Box display='flex' alignItems='center'>
              <Icon fontSize='small' style={{ marginRight: 8 }} />
              <Typography style={dense ? { fontSize: 12 } : undefined}>{leadSourceLabel(selected)}</Typography>
            </Box>
          )
        }}
      >
        <MenuItem value=''>
          <Typography color='textSecondary'>{i18n.t('contactModal.form.leadSource.unset')}</Typography>
        </MenuItem>
        {LEAD_SOURCES.map(source => (
          <MenuItem key={source.value} value={source.value}>
            <Box display='flex' alignItems='center'>
              <source.Icon fontSize='small' style={{ marginRight: 8 }} />
              <Typography>{leadSourceLabel(source.value)}</Typography>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export const LeadSourceIconButton = ({ value, onClick, size = 'small' }) => {
  const source = LEAD_SOURCES.find(s => s.value === value)
  const title = leadSourceLabel(value)

  return (
    <Tooltip title={title}>
      <IconButton size={size} onClick={onClick}>
        {source ? <source.Icon fontSize='small' /> : <MoreHorizIcon fontSize='small' style={{ opacity: 0.4 }} />}
      </IconButton>
    </Tooltip>
  )
}

export default LeadSourceSelector
